// extracted by mini-css-extract-plugin
export var heroImage = "_mh-1";
export var modal = "_mh-0";